$(document).ready(function(){

    
	$('#client-slider').owlCarousel({
	     margin:30,
	     loop:true,
		 slideSpeed : 5000,
		paginationSpeed : 400,
		autoplay:true,
		nav:true,
		pagination:false,  dots: false,
		navText: ["<img src='https://cdn.shopify.com/s/files/1/0293/4118/8175/files/serivce-btn-icon.png?v=1696484151'>","<img src='https://cdn.shopify.com/s/files/1/0293/4118/8175/files/serivce-btn-icon.png?v=1696484151'>"],
	    responsive:{
	        0:{
	            items:1
	        },
	        480:{
	            items:1
	        },
	        700:{
	            items:2
	        },
	        1000:{
	            items:3
	        },
	        1100:{
	            items:4
	        }
	    }
	}); 



});

jQuery(document).ready(function($) {
  $(".s-faq-area .accordion-heading").click(function(e) {
    let accordionBox = $(this).closest(".accordion-box");

    if (!accordionBox.hasClass("open")) {
      $(".accordion-box .accordion_body").slideUp();
      $(".accordion-box").removeClass("open");

      accordionBox.find(".accordion_body").slideDown();
      accordionBox.addClass("open");
    } else {
      accordionBox.find(".accordion_body").slideUp();
      accordionBox.removeClass("open");
    }
  });
});





 
